import StyledImage from "./styles";

const BrandItem = ({ image }) => {
  return <StyledImage src={image} alt="brand item" />;
};

export default BrandItem;
